export default __webpack_public_path__ + "static/media/Like - Selected.6f9912fb.svg";